import api from '../utilBackoffice';

const controller = 'ComissionamentoListaServico';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url, dto),
  Create: dto => api.Axios.Post(url, dto),
  Update: dto => api.Axios.PutCommand(url, dto),
  Delete: dto => api.Axios.DeleteCommand(url, dto)
});
